/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { ClusterId } from '@shared/types/cluster';
import {
  NebulaClusterAccessListRequestBody,
  NebulaClusterDeploymentRequestBody,
  NebulaClusterDeploymentResponseBody,
} from '@shared/types/nebula';

export const loadNebulaPricesErr = createAction('[Cluster Management] Load nebula prices error', props<GmcError>());
export const deployNebulaCluster = createAction(
  '[Cluster Management] Deploy Nebula Cluster',
  props<{ args: NebulaClusterDeploymentRequestBody }>(),
);
export const deployNebulaClusterStarted = createAction(
  '[Cluster Management] Deploy Nebula Cluster started',
  props<{ data: NebulaClusterDeploymentResponseBody; notification?: string }>(),
);
export const deployNebulaClusterErr = createAction('[Cluster Management] Deploy Nebula Cluster err', props<GmcError>());

export const deployNebulaClusterOk = createAction(
  '[Cluster Management] Deploy Nebula Cluster OK',
  props<{ clusterId: ClusterId; notification?: string }>(),
);

export const destroyNebulaCluster = createAction(
  '[Cluster Management] Destroy Nebula cluster',
  props<{ clusterId: ClusterId }>(),
);
export const destroyNebulaClusterOk = createAction(
  '[Cluster Management] Destroy Nebula cluster OK',
  props<{ clusterId: ClusterId; notification?: string }>(),
);
export const destroyNebulaClusterErr = createAction(
  '[Cluster Management] Destroy Nebula cluster err',
  props<GmcError & { clusterId: ClusterId }>(),
);

export const loadNebulaClusterAccessListErr = createAction(
  '[Cluster Management] Load Nebula Cluster Access list err',
  props<GmcError>(),
);
export const updateNebulaClusterAccessList = createAction(
  '[Cluster Management] Update Nebula Cluster Access list',
  props<{ args: NebulaClusterAccessListRequestBody }>(),
);
export const updateNebulaClusterAccessListOk = createAction(
  '[Cluster Management] Update Nebula Cluster Access list OK',
  props<{ notification: string }>(),
);
export const updateNebulaClusterAccessListErr = createAction(
  '[Cluster Management] Update Nebula Cluster Access list Err',
  props<GmcError & { clusterId: ClusterId }>(),
);

export const getCloudProviderRegionsErr = createAction(
  '[Cluster Management] Get cloud provider regions err',
  props<GmcError>(),
);

export const renameCluster = createAction(
  '[Cluster Management] Rename cluster',
  props<{ clusterId: ClusterId; tag: string }>(),
);
export const renameClusterOk = createAction(
  '[Cluster Management] Rename cluster OK',
  props<{ clusterId: ClusterId; tag: string; notification?: string }>(),
);
export const renameClusterErr = createAction(
  '[Cluster Management] Rename cluster err',
  props<GmcError & { clusterId: ClusterId; tag: string }>(),
);

// Suspend Nebula cluster
export const suspendNebulaClusterIntent = createAction(
  '[Cluster Management] Suspend intent',
  props<{ clusterId: ClusterId }>(),
);
export const suspendNebulaCluster = createAction('[Cluster Management] Suspend', props<{ clusterId: ClusterId }>());
export const suspendNebulaClusterOK = createAction(
  '[Cluster Management] Suspend success',
  props<{ clusterId: ClusterId }>(),
);
export const suspendNebulaClusterErr = createAction(
  '[Cluster Management] Suspend error',
  props<{ clusterId: ClusterId } & GmcError>(),
);

// Resume suspended Nebula cluster
export const resumeSuspendedNebulaClusterIntent = createAction(
  '[Cluster Management] Resume intent',
  props<{ clusterId: ClusterId }>(),
);
export const resumeSuspendedNebulaCluster = createAction(
  '[Cluster Management] Resume',
  props<{ clusterId: ClusterId }>(),
);
export const resumeSuspendedNebulaClusterOK = createAction(
  '[Cluster Management] Resume success',
  props<{ clusterId: ClusterId }>(),
);
export const resumeSuspendedNebulaClusterErr = createAction(
  '[Cluster Management] Resume error',
  props<{ clusterId: ClusterId } & GmcError>(),
);
export const loadNebulaAccountsListErr = createAction(
  '[Cluster Management] Load Nebula Accounts list err',
  props<GmcError>(),
);
